// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './media-avatar-addon.component';
export * from './media.module';
// @endindex